module.exports = __webpack_public_path__ + "img/tundra.aa5fd16b.png";